import template from './hint-block.jade';
import app from '../../scripts/app';

app.directive('cianAfHintBlock', () => ({
    restrict : 'E',
    scope: {},
    bindToController: {
      hintText: '<',
      title: '@',
      width: '@?',
    },
    controller(deviceService, popupService) {
      'ngInject';
      const blockWidth = this.width ? `width: ${this.width}px` : '';

      this.isMobile = deviceService.isMobile;

      this.openTooltipModal = () => {
        popupService.openPopup('hint', {
          text: this.hintText,
          title: this.title,
          hideCloseButton: false,
        });
      };

      this.hintHtml = `
        <div class="hint-block__text" style="${blockWidth}">${this.hintText}</div>
      `;
    },
    controllerAs: 'hintBlock',
    template,
  }));
